module.exports = __webpack_public_path__ + "static/media/images.8f2fc062.svg";